export default "__VITE_ASSET__JBxGW0G$__"